import PlacesPage from '../PlacesPage';

const ComplexesPage = (props) => (
  <PlacesPage
    {...props}
    pageTitle="מתחמים וקניונים"
    itemLabel="מתחמים"
    showPlaceKindFilter={false}
  />
);

export default ComplexesPage;
